
function SdOrderItemsCtrl(TranslationService, MaterialService, StoreService, ToastService, DocService, AllocService, $uibModal) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.showDiffs = true;
    ctrl.maxContainers = 30;
    ctrl.notIncludeTaxesMsg = 'Not include taxes';

    ctrl.$onChanges = function (newValues, oldValues) {
        if (newValues.order) {
            if (newValues.order.currentValue && newValues.order.currentValue.Details) {
                ctrl.prepareForEdit(newValues.order.currentValue);
            }
        }

        //Executa quantityClicked
        if (newValues.indexQuantity) {
            if (ctrl.order && ctrl.order.Details) {
                var index = newValues.indexQuantity.currentValue;
                if (index >= 0) {
                    ctrl.quantityClicked(ctrl.order.Details[index], index);
                }
            }
        }
    };

    ctrl.prepareForEdit = function (order) {
        //console.log('prepare for edit');
        loadContactAddresses(order.ContactID);
        /*        
        var points = order.Details.reduce(
            function (pos, detail) {
                var index = pos.findIndex(
                    function (p) {
                        return p.PointID == detail.PointID;
                    }
                )
                if (index < 0) {
                    pos.push({
                        PointID: detail.PointID
                    });
                }
                return pos;
            },
            []
        );
        order.Points = points;
        */
        //console.log(order);
    };

    ctrl.materialSearch = function (query) {
        return MaterialService.getMaterialsQuery(query)
            .then(function (response) {
                return response.data.map(function (item) {
                    return item;
                });
            })
            .catch(function (err) {
                console.error(err);
            });
    };

    ctrl.materialSelected = function (item) {
        console.log('MATERIALSELECTED ' + item.MaterialID)
        //item.Material = {
        //    Sequence: 0
        //};
        //ctrl.copyMaterial(item.Material, item);
        //ctrl.getMaterialAllocs(item);
        //ctrl.getMaterialAlternatives(item);
    };

    ctrl.addLine = function (item) {
        return AllocService.addLine(item);
    };

    ctrl.qtOrderChanged = function (detail) {        
        ctrl.recalcTotals(ctrl.order);
    };

    ctrl.recalcTotals = function (order) {
        console.log('RecalcTotals');
        order.TotalQuantity = 0;
        order.TotalVolume = 0;
        try {
            for (var i = 0; i < order.Details.length; i++) {
                var detail = order.Details[i];
                if (detail.MaterialID) {
                    if (detail.Quantity) {
                        order.TotalQuantity += detail.Quantity;
                    }
                }
            }
        }
        catch (err) {
            order.TotalQuantity = 'Erro!';
            order.TotalVolume = 'Erro!';
        }
    };

    ctrl.removeItem = function (detail) {
        //var listIndex = ctrl.findByIndex(ctrl.order.Details, index);
       
        var index = ctrl.order.Details.findIndex(
            function (d) {
                return d.SeqID == detail.SeqID;
            }
        );

        console.log('removeItem ' + index);
        if (index >= 0) {
            ctrl.order.Details.splice(index, 1);
        }
        //ctrl.recalcTotals(ctrl.order);
        ctrl.onRecalcTotals(ctrl.order);
    };

    ctrl.editBox = function (box) {
        var modalInstance = $uibModal.open({
            templateUrl: 'SPA/orders/editBoxModal.html',
            controller: 'EditBoxCtrl',
            size: 'lg',
            resolve: {
                order: function () {
                    return ctrl.order;
                },
                box: function () {
                    return box;
                }
            }
        });
        modalInstance.result.then(function (selectedItem) { });
    };

    ctrl.editPrices = function (detail) {
        var modalInstance = $uibModal.open({
            templateUrl: 'SPA/orders/editPricesModal.html',
            controller: 'EditPricesCtrl',
            size: 'lg',
            resolve: {
                order: function () {
                    return ctrl.order;
                },
                detail: function () {
                    return detail;
                }
            }
        });
        modalInstance.result.then(function (selectedItem) { });
    };

    ctrl.recalcDetail = function (order, detail) {
        //JRM: RECALC AMMOUNT
        console.log('recalcDetail');
        /*
        console.log('recalcDetail');       
        if (order.isInserting) {
            detail.Quantity = detail.QtBoxes * detail.pc_cx_un_cli;
        }
        detail.PriceAmount = detail.Quantity * detail.UnitPrice;
        */
        //StoreService.recalcDetail(order, detail);
        ctrl.onRecalcTotals(order);
    };

    ctrl.addBox = function (detail, quant) {
        detail.QtBoxes += quant;
        if (detail.QtBoxes < 0) {
            detail.QtBoxes = 0;
        }
        ctrl.recalcDetail(ctrl.order, detail);
    };


    ctrl.getPercContainer = function (detail) {
        //return detail.volume_m3_mbf * detail.Quantity / 22 * 100;
        return StoreService.getPercContainer(detail);
    };

    ctrl.isQuote = function () {
        return StoreService.isQuote(ctrl.order);
    };

    ctrl.showDrawing = function (drawingID) {
        var scope = {};
        DocService.showDrawing(scope, drawingID);
    };

    ctrl.getDrawingID = function (item) {
        return StoreService.getDrawingID(item);
    };

    ctrl.seqIDFunction = function (detail) {        
        if (detail.SeqID) {
            //console.log('seqIDFunction ' + Number(detail.SeqID));
            return Number(detail.SeqID);
        }
        else {
            //console.log('seqIDFunction 00000');
            return 0;
        }
    };

    ctrl.refCodeAllowsDiscount = function (detail) {
        return StoreService.refCodeAllowsDiscount(detail);
    };

    ctrl.isFullContainer = function (detail) {
        return StoreService.isFullContainer(ctrl.order, detail);        
    };

    ctrl.getMessages = function () {
        //var msg = 'Straight load  será considerado para os SKUS quando a QTY for ( igual ou Maior ) volume do full Container';
        //msg += '\n';
        var msg = ' Volume considered for  Straight load';
        return msg;
    };

    ctrl.getSkuTitle = function (detail) {
        var msg = 'Open image ' + detail.DrawingID;
        msg += '\n';
        msg += 'Ref Code ' + detail.RefCode;
        msg += '\n';
        msg += 'Straight Load only for Ref Codes above ' + StoreService.MIN_STRAIGHT_LOAD_REF_CODE;
        return msg;
    };

    ctrl.isEditingOrInserting = function () {
        return ctrl.order.isEditing || ctrl.order.isInserting;
    };

    ctrl.addProductModal = function (order, pointID) {
        var modalInstance = $uibModal.open({
            templateUrl: './SPA/orders/addProductModal.html',
            controller: 'AddProductModalController',
            size: 'xl',
            resolve: {
                order: function () {
                    return order;
                },
                pointID: function () {
                    return pointID;
                }
            }
        });
        return modalInstance;
    };

    ctrl.addProduct = function (pointID) {
        //abrir FORM SELECIONAR PRODUTOS
        var order = ctrl.order;
        var modal = ctrl.addProductModal(order, pointID);
        modal.result.then(function (sku) {
            console.log('ADD PRODUCT');
            console.log(sku);
            var currencySymbol = 'US$';
            var newItem = StoreService.addCartProduct(order, sku, currencySymbol);
            if (newItem) {
                newItem.isNew = true;
            }
            order.isInserting = false;
            //return AllocService.addLine(item);
        });
    };

    //ctrl.pointAddresses = function (pointID) {
    //    console.log('pointAddresses ' + pointID);
    //    if (!ctrl.contactAddresses) {
    //        loadContactAddresses(ctrl.order.ContactID);
    //    }
        
    //    var filtered = ctrl.contactAddresses.filter(
    //        function (adr) {
    //            return (adr.PointID == pointID);
    //        }
    //    );
    //    return filtered;
    //};

    function loadContactAddresses(contactID) {
        ctrl.contactAddresses = [];
        StoreService.getContactAddresses(contactID).then(
            function (result) {
                ctrl.contactAddresses = result.data;                
                //preenche points com enderecos
                fillContactAddresses(ctrl.order, result.data);
            }
        );
    }

    function fillContactAddresses(order, addresses) {
        console.log('fillContactAddresses ' + addresses.length);
        for (var i in order.Details) {
            var d = order.Details[i];
            d.pointAddresses = filterAddresses(addresses, d.PointID);
        }
    }

    function filterAddresses(addresses, pointID) {
        return addresses.filter(
            function (adr) {
                return (adr.PointID == pointID);
            }
        );
    }
}

SdOrderItemsCtrl.$inject = ['TranslationService', 'MaterialService', 'StoreService', 'ToastService', 'DocService', 'AllocService', '$uibModal'];

seedWebApp.component('sdOrderItems', {
    controller: SdOrderItemsCtrl,
    bindings: {
        loading: '<',
        order: '<',
        disabled: '<',
        selIndex: '=',
        settings: '<',
        onRefresh: '=',
        onRecalcTotals: '=',
    },
    templateUrl: '/SPA/Orders/sd-order-items.html' + seedWebApp.buildVersion
});
